// import React, { useState, useEffect } from 'react';
import React, { useState } from 'react';
import Router from 'next/router';
import Header from 'components/Common/WXHeader';
import makeStyles from '@material-ui/styles/makeStyles';
import Container from '@material-ui/core/Container';
import { post } from 'utils/request';

import Item from 'components/Home/Item';

import { db } from '../config';

const {
  host: { java }
} = db;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    background: '#F7F8FA',
    flexDirection: 'column',
    minHeight: '100vh',
    padding: 0
  },
  tabs: {
    display: 'flex',
    background: '#FFFFFF',
    alignItems: 'center',
    height: theme.spacing(6)
  },
  tab: {
    display: 'flex',
    height: '100%',
    flex: 1,
    fontSize: 15,
    fontWeight: 400,
    color: '#3B454F',
    lineHeight: '23px',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid #D8E3EB',
    '& img': {
      marginRight: theme.spacing(1)
    },
    '&:first-child': {
      borderRight: '1px solid #D8E3EB',
      '& img': {
        width: 19,
        height: 17
      }
    },
    '&:last-child img': {
      width: 15,
      height: 18
    },
    '& b': {
      color: '#43C494'
    }
  },
  items: {
    display: 'flex',
    paddingTop: 10,
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  }
}));

function Index(props) {
  const { list = [], query = {} } = props;
  const [t] = useState(query.token || '');
  const [isAndroid] = useState(query.isAndroid || '');
  const [zmWealth] = useState(query.zmWealth || 0);
  const [version] = useState(query.v || 0);
  // const [t, setT] = useState(query.token || '');
  // const [isAndroid, setIsAndroid] = useState(query.isAndroid || '');
  // const [zmWealth, setZmWealth] = useState(query.zmWealth || 0);
  // const router = Router.router || {};
  // useEffect(() => {
  //   if (query) {
  //     setT(query.token);
  //     setIsAndroid(query.isAndroid);
  //     setZmWealth(query.zmWealth);
  //   }
  // }, [query, query.isAndroid, query.token, query.zmWealth, router]);
  const styles = useStyles();
  async function goPage(e) {
    // alert(JSON.stringify(Router));
    // e.stopPropagation();
    const { path } = e.currentTarget.dataset;
    await Router.push(path);
  }

  return (
    <Container className={styles.root}>
      <Header title="知米周边商城" />
      <div className={styles.tabs}>
        <div className={styles.tab}>
          <img
            alt="知米币"
            src="//zhimi-read.oss-cn-hangzhou.aliyuncs.com/zhimi/image/ab-coin.png"
          />
          <span>
            知米币<b>{zmWealth}</b>
          </span>
        </div>
        <div
          data-path={`/record/list?t=${t}&isAndroid=${isAndroid}&version=${version}`}
          onClick={goPage}
          onTouchEnd={goPage}
          className={styles.tab}
          style={{ cursor: 'pointer' }}
        >
          <img
            alt="兑换记录"
            src="//zhimi-read.oss-cn-hangzhou.aliyuncs.com/zhimi/image/ab-record.png"
          />
          <span>兑换记录</span>
        </div>
      </div>
      <div className={styles.items}>
        {list.map(item => (
          <Item
            onClick={goPage}
            key={item.id}
            version={version}
            {...item}
            t={t}
            isAndroid={isAndroid}
          />
        ))}
      </div>
    </Container>
  );
}

Index.getInitialProps = async({ query }) => {
  const obj = {};
  const resData = await post({
    url: `${java}/youqu/newShop/getCommodities.htm`,
    data: query
  });
  const { token = '', isAndroid = true } = query;
  const resInfo = await post({
    url: `${java}/youqu/newShop/getUserInfo.htm`,
    data: {
      t: token,
      isAndroid,
    }
  });
  const { data = [] } = resData || {};
  const { data: { zmWealth = 0 } } = resInfo;
  if (resData.statusCode === 20000 && resInfo.statusCode === 20000) {
    obj.list = data;
    obj.query = {
      ...query,
      zmWealth,
    };
  }
  return obj;
};

export default Index;
